import React from 'react';
import { TruckIcon, BanknoteIcon, ShieldCheckIcon } from 'lucide-react';
interface TrustBadgesProps {
  className?: string;
}
export function TrustBadges({
  className = ''
}: TrustBadgesProps) {
  return <div className={`flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6 mt-4 text-sm font-medium text-slate-700 ${className}`} data-id="element-231">
      <div className="flex items-center gap-2" data-id="element-232">
        <TruckIcon className="w-5 h-5 text-blue-600" data-id="element-233" />
        <span data-id="element-234">Envío Gratis a Todo México</span>
      </div>
      <div className="flex items-center gap-2" data-id="element-235">
        <BanknoteIcon className="w-5 h-5 text-green-600" data-id="element-236" />
        <span data-id="element-237">Pago Contra Entrega</span>
      </div>
      <div className="flex items-center gap-2" data-id="element-238">
        <ShieldCheckIcon className="w-5 h-5 text-blue-600" data-id="element-239" />
        <span data-id="element-240">Garantía de 30 Días</span>
      </div>
    </div>;
}